import { ref, computed, onMounted, onUnmounted } from 'vue'

/**
 * Composable for managing module sidebar state on mobile
 * Handles open/close state, mobile detection, and body class management
 */
export function useModuleSidebar() {
  const isMobileSidebarOpen = ref(false)
  const isMobile = ref(false)

  // Check if we're on mobile
  const checkMobile = () => {
    const wasMobile = isMobile.value
    isMobile.value = window.innerWidth <= 768
    
    // If transitioning from desktop to mobile, close sidebar
    if (!wasMobile && isMobile.value) {
      closeSidebar()
    }
  }

  // Open sidebar (mobile only)
  const openSidebar = () => {
    if (isMobile.value) {
      isMobileSidebarOpen.value = true
      document.body.classList.add('module-sidebar-open')
    }
  }

  // Close sidebar
  const closeSidebar = () => {
    isMobileSidebarOpen.value = false
    document.body.classList.remove('module-sidebar-open')
  }

  // Toggle sidebar
  const toggleSidebar = () => {
    if (isMobileSidebarOpen.value) {
      closeSidebar()
    } else {
      openSidebar()
    }
  }

  // Computed class for sidebar
  const sidebarClass = computed(() => {
    return {
      'sidebar-open': isMobile.value && isMobileSidebarOpen.value
    }
  })

  onMounted(() => {
    checkMobile()
    window.addEventListener('resize', checkMobile)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile)
    closeSidebar()
  })

  return {
    isMobile,
    isMobileSidebarOpen,
    openSidebar,
    closeSidebar,
    toggleSidebar,
    sidebarClass
  }
}

